import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const fertilizerSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  fertilizer_type: required({ t })(Yup.string()),
  origin: required({ t })(Yup.string()),
  fertilizer_maker_name: required({ t })(Yup.string())
})


export default fertilizerSchema
